/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { State } from "store/reducers";
import ls from "Localization";
import _ from "lodash";
import { Helmet } from "react-helmet-async";

import actions from "store/actions";

import IEmails from "Types/Emails";
import dayjs from "dayjs";
import Report from "Components/Report";

import ReactTable from "react-table";
import { EmailsState } from "store/reducers/emails";
import { dateSort } from "Components/Report/helpers";
import DateSelectFilter from "Components/Report/DateSelectorFilter";
import Tooltip from "Components/Tooltip";

const ls2: any = ls;

let getDasesDebounced: (() => any) & _.Cancelable = _.debounce(() => {}, 250);

function Emails() {
	const dispatch = useDispatch<any>();
	const table = useRef<ReactTable<any>>(null);

	const state = useSelector<State, EmailsState>(s => s.emails);

	const handleFetchData = (tableState: any) => {
		if (!tableState) return;
		const { page, pageSize, toExport, callback } = tableState;
		let { sorted, filtered } = tableState;

		if (getDasesDebounced) {
			getDasesDebounced.cancel();
		}

		if (!sorted) sorted = [];

		const creationDate = filtered.find((c: any) => c.id === "createdAt");

		if (creationDate?.value) {
			filtered = filtered.filter((c: any) => c.id !== "createdAt");

			if (creationDate?.value.startDate) {
				filtered.push({
					id: "startDate",
					value: creationDate.value.startDate
				});
			}

			if (creationDate?.value.endDate)
				filtered.push({
					id: "endDate",
					value: creationDate.value.endDate
				});
		}

		getDasesDebounced = _.debounce(
			() =>
				dispatch(
					actions.emails.getEmails(
						page * pageSize,
						pageSize,
						filtered.reduce(
							(p: any, c: any) => p + `&filters[${c.id}]=${c.value}`,
							""
						),
						sorted[0]?.id,
						sorted[0]?.desc,
						toExport,
						callback
					)
				),
			500
		);

		getDasesDebounced();
	};

	const load = () => handleFetchData(table.current?.state);

	const columns = [
		{
			Header: ls.createdAt,
			id: "createdAt",
			accessor: (d: IEmails) =>
				d.createdAt
					? dayjs(d.createdAt).format(ls.dateFormatWithoutSeconds)
					: "",
			show: true,
			sortMethod: dateSort,
			Filter: p => <DateSelectFilter {...p} />,
			width: 220
		},
		{
			Header: ls.email,
			accessor: c => c.data.email,
			id: "email",
			show: true,
			width: 250
		},
		{
			Header: "Informação",
			accessor: c => c.data.url || c.data.reason,
			id: "info",
			show: true
		},
		{
			Header: ls.event,
			accessor: (c: IEmails) => {
				if (c.data.event === "bounce") {
					return <Tooltip title={c.data.reason}>{c.data.event}</Tooltip>;
				}

				return c.data.event;
			},
			id: "event",
			show: true,
			width: 130
		},
		{
			Header: ls.tag,
			accessor: (c: IEmails) => {
				return c.data.tag;
			},
			id: "tag",
			show: true,
			width: 130
		}
	];

	return (
		<div>
			<Helmet>
				<title>{ls.emailHistory}</title>
			</Helmet>
			<Report
				manual
				tableRef={table}
				headerRightComponent={<></>}
				titleText="Emails"
				title={ls.emailHistory}
				data={state.items}
				pages={state.pages}
				loading={state.loading.getAll}
				columns={columns}
				onFetchData={handleFetchData}
				filterable
				visibleColumns={columns
					.filter(c => c.show)
					.map(c => c.Header.toString())}
				defaultSorted={[
					{
						id: "createdAt",
						desc: true
					}
				]}
				getTdProps={() => {
					return {
						style: {
							display: "flex",
							alignItems: "center"
						}
					};
				}}
			/>
		</div>
	);
}

export default Emails;
